import {DashboardTileCatalogueEntry} from '../types/DashboardTileCatalogueEntry';
import {DashboardTileId} from '../types/DashboardTileId';

export const DASHBOARD_TILE_CATALOGUE: Record<DashboardTileId, DashboardTileCatalogueEntry> = {
  'recommended-actions': {
    labelKey: 'page.interestMyDay.recommendations.title',
    sizes: ['half', 'wide', 'tall'],
    defaultSize: 'wide',
  },
  'opportunities-funnel': {
    labelKey: 'page.homepage.labels.currentOpportunities',
    sizes: ['wide', 'tall'],
    defaultSize: 'wide',
  },
  'workshop-overview': {
    labelKey: 'page.homepage.workshopOverview.title',
    sizes: ['half', 'wide'],
    defaultSize: 'half',
  },
  'vehicle-warehouse': {
    labelKey: 'page.homepage.labels.vehicleWarehouse',
    sizes: ['half', 'tall', 'wide'],
    defaultSize: 'half',
  },
  support: {
    labelKey: 'page.homepage.labels.support',
    sizes: ['half'],
    defaultSize: 'half',
  },
  'latest-vehicles': {
    labelKey: 'page.homepage.labels.latestVehicles',
    sizes: ['half', 'tall', 'wide'],
    defaultSize: 'half',
  },
  'my-tasks': {
    labelKey: 'entity.task.labels.myTasks',
    sizes: ['quarter', 'half'],
    defaultSize: 'quarter',
  },
  notifications: {
    labelKey: 'page.homepage.labels.myNotifications',
    sizes: ['quarter', 'half'],
    defaultSize: 'quarter',
  },
  'latest-business-cases': {
    labelKey: 'page.homepage.labels.latestBusinessCases',
    sizes: ['half', 'tall', 'wide'],
    defaultSize: 'half',
  },
  'latest-interests': {
    labelKey: 'page.homepage.labels.latestInterests',
    sizes: ['half', 'tall', 'wide'],
    defaultSize: 'half',
  },
};
